<template>
  <div class="refund-gorders-container">
    <el-row :gutter="20" class="search-row">
      <el-col :span="6">
        <el-input
          v-model="searchParams.prodNameLike"
          :placeholder="$t('adminRefundGroupOrder.product')"
          clearable
        ></el-input>
      </el-col>
      <el-col :span="6">
        <el-input
          v-model="searchParams.buyerNameLike"
          :placeholder="$t('adminRefundGroupOrder.buyer')"
          clearable
        ></el-input>
      </el-col>
      <el-col :span="2">
        <el-button type="primary" @click="handleSearch">
          {{ $t('common.search') }}
        </el-button>
      </el-col>
    </el-row>

    <el-table
      :data="tableData"
      border
      style="width: 100%"
      class="margin-top"
    >
      <el-table-column prop="shopName" :label="$t('adminRefundGroupOrder.shop')" align="center"></el-table-column>
      <el-table-column prop="returnId" :label="$t('adminRefundGroupOrder.refundNo')" align="center"></el-table-column>
      <el-table-column prop="orderId" :label="$t('adminRefundGroupOrder.order')" align="center"></el-table-column>
      <el-table-column prop="prodName" :label="$t('adminRefundGroupOrder.product')" align="center"></el-table-column>
      <el-table-column prop="buyerName" :label="$t('adminRefundGroupOrder.buyer')" align="center"></el-table-column>
      <el-table-column prop="buyerCount" :label="$t('adminRefundGroupOrder.buyQuantity')" align="center"></el-table-column>
      <el-table-column prop="groupPrice" :label="$t('adminRefundGroupOrder.groupPrice')" align="center"></el-table-column>
      <el-table-column prop="returnMoney" :label="$t('adminRefundGroupOrder.refundAmount')" align="center"></el-table-column>
      <el-table-column prop="returnType" :label="$t('adminRefundGroupOrder.refundType')" align="center">
        <template #default="scope">
          {{ scope.row.returnType === '1001' ? $t('adminRefundGroupOrder.selfRefund') : $t('adminRefundGroupOrder.groupFailedRefund') }}
        </template>
      </el-table-column>
      <el-table-column prop="reason" :label="$t('adminRefundGroupOrder.refundReason')" align="center"></el-table-column>
      <el-table-column prop="state" :label="$t('adminRefundGroupOrder.status')" align="center"></el-table-column>
      <el-table-column prop="stateMsg" :label="$t('adminRefundGroupOrder.auditRemark')" align="center"></el-table-column>
    </el-table>

    <el-pagination
      class="margin-top"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pagination.currentPage"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pagination.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pagination.total"
    ></el-pagination>
  </div>
</template>

<script>
import { queryAdminRefundGroupOrder } from '@/api/group/refundGroupOrderApi'

export default {
  name: 'AShopDetailRefundGOrders',

  data() {
    return {
      searchParams: {
        prodNameLike: '',
        buyerNameLike: ''
      },
      tableData: [],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  created() {
  },
  methods: {
    open(params) {
      this.shopId = params.shopId
      this.loadData()
    },
    async loadData() {
      try {
        const params = {
          shopId: this.shopId,
          prodNameLike: this.searchParams.prodNameLike,
          buyerNameLike: this.searchParams.buyerNameLike,
          page: this.pagination.currentPage,
          row: this.pagination.pageSize
        }
        
        const res = await queryAdminRefundGroupOrder(params)
        this.tableData = res.data
        this.pagination.total = res.records
      } catch (error) {
        console.error('获取拼团退单列表失败:', error)
      }
    },
    handleSearch() {
      this.pagination.currentPage = 1
      this.loadData()
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.loadData()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.loadData()
    }
  }
}
</script>

<style scoped>
.refund-gorders-container {
}
.search-row {
  margin-bottom: 20px;
}
.margin-top {
  margin-top: 20px;
}
</style>